import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'discountsFilter'
})
export class DiscountsFilterPipe implements PipeTransform {
  transform(items: Array<any>, discount: number): Array<any> {
    return items.filter(item => item.descuento === discount);
  }
}
